import { DepositPhase, DepositState, PaymentStateStatus } from "../../payments/PaymentsReducer";
import ChooseAmount from "../deposit/ChooseAmount";
import { t } from "../../i18n";
import { DepositResultCode, PaymentDialog, Settings } from "../../http/protocol";
import { useSelector } from "react-redux";
import DepositProviderContent from "../deposit/DepositProviderContent";
import { getDeposit } from "../../selectors/payments-selectors";
import CloseIcon from "../../utils/closeIcon";
import "./MayaMiniAppDepositPaymentComponent.scss";
import VerifyIcon from "../../utils/verifyIcon";
import { BrandA } from "../buttons/buttons";

interface Props {
  handleClickOk?: () => void;
  handleClickStartPlaying?: () => void;
  deposit?: DepositState;
  dialog?: PaymentDialog;
  settings?: Settings;
  fromBonus?: boolean;
}

export function MayaMiniAppDepositPaymentComponent(props: Props) {
  const deposit = useSelector(getDeposit);
  const customContext = deposit.depositDialog?.customContext;
  const depositResult = customContext?.depositResult;
  const isDepositOk = depositResult?.result === DepositResultCode.OK;
  const isPaymentError = deposit.status === PaymentStateStatus.DEPOSIT_ERROR_INITIALIZING;
  const isDepositResultPhase = deposit.phase === DepositPhase.DEPOSIT_RESULT;
  const externalErrorId = customContext?.externalErrorId;
  const isDepositError = isDepositResultPhase && !isDepositOk;
  const hasError = isDepositError || isPaymentError;

  if (!deposit) return null;

  return (
    <div className="mayaminiapp-wrapper">
      {deposit.phase === DepositPhase.CHOOSE_AMOUNT && <ChooseAmount />}
      {deposit.phase === DepositPhase.PROVIDER_CONTENT && !isPaymentError && <DepositProviderContent />}
      {isDepositResultPhase && isDepositOk && (
        <div className="request-wrapper success">
          <VerifyIcon className={`check-icon`} animate={true} />
          <span>{t("mayaminiapp.deposit.success")}</span>
          {props.handleClickStartPlaying && (
            <BrandA className={"btn btn-cta full-width start-playing"} onClick={props.handleClickStartPlaying}>
              {t("global.startPlaying")}
            </BrandA>
          )}
        </div>
      )}
      {hasError && <MayaMiniAppDepositError errorId={externalErrorId} />}
    </div>
  );
}

enum MayaMiniAppErrorId {
  INSUFFICIENT_FUNDS = "PYMY001",
  OVER_LIMIT = "PY0123",
}

const MayaMiniAppDepositError = ({ errorId }: { errorId: MayaMiniAppErrorId }) => {
  const getErrorMessage = (errorId: string) => {
    switch (errorId) {
      case MayaMiniAppErrorId.INSUFFICIENT_FUNDS:
        return t("mayaminiapp.deposit.insufficientFunds");
      case MayaMiniAppErrorId.OVER_LIMIT:
        return t("mayaminiapp.deposit.overLimit");
      default:
        return t("mayaminiapp.deposit.error");
    }
  };
  const errorMessage = getErrorMessage(errorId);

  return (
    <div className="request-wrapper">
      <CloseIcon className={`invalid-icon`} animate={true} />
      <span>{errorMessage}</span>
    </div>
  );
};